import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import ChevronLeft from './Icons/ChevronLeft.js';
const Back = (props) => (React.createElement(Wrapper, null,
    React.createElement(BackButton, { onClick: () => {
            props.onClick();
        } },
        React.createElement(ChevronLeft, null)),
    props.header || null));
export default Back;
const Wrapper = styled.div `
  padding: 0.5em;
  align-items: center;
  background: ${THEME.COLOR_ACCENT};
  color: ${THEME.COLOR_SECONDARY};
  text-align: center;
  width: 100%;
  font-weight: normal;
  min-height: 2.1em;
`;
const BackButton = styled.div `
  cursor: pointer;
  position: absolute;
`;
//# sourceMappingURL=Back.js.map